import { z } from "zod";
import { InvoiceJournalEntryMode } from "@common/types/integrationAccount";

export const stripeInvoiceJournalEntryModeParamsSchema = z.object({
    workspaceId: z.string().uuid(),
    integrationAccountId: z.string().uuid(),
});

export const stripeInvoiceJournalEntryModeBodySchema = z.object({
    invoiceJournalEntryMode: z.nativeEnum(InvoiceJournalEntryMode),
});

export const stripeInvoiceJournalEntryModeResponseSchema = z.object({
    invoiceJournalEntryMode: z.nativeEnum(InvoiceJournalEntryMode),
});
